import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsMobileFilterActions.module.scss";
import {useSongsMobileFilterActionsLogic} from "./SongsMobileFilterActions.logic";
import Button from "../../../../../../components/common/Button";

export const SongsMobileFilterActions: VoidFunctionComponent = () => {
  const {handleDoneOnClick, handleResetOnClick} = useSongsMobileFilterActionsLogic();
  return (
    <div className={s.container}>
      <Button buttonType={"secondary"} text={"Done"} onClick={handleDoneOnClick} />
      <Button text={"Reset All Filters"} onClick={handleResetOnClick} />
    </div>
  );
}
